var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeleteThumbIcon = function SvgDeleteThumbIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 22 0 22 22 0 22"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.456 2.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.593 0c.602 0 1.143.368 1.363.928l.583 1.48 3.536.001v1.466h-1.483l-.563 11.286A1.41 1.41 0 0 1 11.62 16.5H3.454a1.41 1.41 0 0 1-1.407-1.339L1.48 3.874H0V2.41h3.535l.584-1.48C4.339.368 4.88 0 5.482 0h4.11Zm-.001 1.465h-4.11l-.372.944h4.854l-.372-.944Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "5.31125776 5.93083333 7.56199896 8.18016253 9.7679089 5.97495859 11.0916667 7.29871636 8.88575673 9.50392029 11.0475414 11.667117 9.72378364 12.9908747 7.56129296 10.8283841 5.35538302 13.035 4.03162526 11.7112422 6.2375352 9.50462629 3.9875 7.2545911"
  })))));
};

export default SvgDeleteThumbIcon;